import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { findParentComponentByName } from '../../utility/vue-helpers';
import './dt-grid.scss';

// TopRightMenu new Props - HTML/Mode

@Component({
  name: 'GridBox'
})
export default class GridBox extends Vue {
  @Prop({ default: "Box" }) title;
  @Prop({ default: false }) loading;
  @Prop({ default: '' }) titleIcon;
  @Prop({ default: '' }) titleIconText;
  @Prop({}) span;
  @Prop({}) h;
  @Prop({}) maxH;
  @Prop({ default: 'white' }) bc;

  height = null;
  // @Prop({}) selected;
  get selected() {
    const gl = findParentComponentByName(this, 'GridLayout');
    return gl.selectedBox == this.title;
  }

  makeBoxSelected() {
    console.log(this.$el.parentElement.parentElement.parentElement.parentElement);
    console.log({ "parentElement": this.$parent.$parent });

    const gl = findParentComponentByName(this, 'GridLayout');
    console.log({ "gl": gl });
    gl.onGridBoxSelected(this.title);
  }

  toggleExpandCollapse(expandState) {
    if (expandState) {
      this.height = this.maxH;
    } else {
      this.height = this.h;
    }
  }

  render(h) {
    return (
      <div style={{
        height: `${(this.height || this.h)}px`,
        '--bw-bc': this.bc,
      }} class={`dt-grid-box hoverFC2 ${this.selected ? 'selected' : ''} ${this.loading ? 'dt-loading' : ''}`}>
        <div class="dt-box-header" onClick={this.makeBoxSelected}>
          <div class="dt-box-header--name">
            
          {this.titleIcon && this.titleIcon!=''? 
            <div class="ut-flex"> <div style="margin-top:-5px"> {this.title} </div> <img title={this.titleIconText} style="height:30px;width:30px;margin-top:-5px;cursor:pointer" src={this.titleIcon} alt /> </div>
            : this.title 
          }

            
          </div>
        </div>
        <div class="dt-box-body" onClick={this.makeBoxSelected}>
          {this.$slots.default}
          {this.loading && <div class="dt-box-body--loading">
            <img src="static/icons/loading.gif" alt />
          </div>}
        </div>
      </div>
    );
  }
}
